import Vue from 'vue';
import Vuex from 'vuex';

import core from '@/modules/core/store';
import user from '@/modules/user/store';
import catalog from '@/modules/catalog/store';
import checkout from '@/modules/checkout/store';
import level4 from '@/modules/level4/store';
import page from '@/modules/page/store';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    core,
    user,
    level4,
    catalog,
    checkout,
    page,
  },
});
